/** Short WebAudio tones, no sound files. The browser stays silent until the page has had a click. */

/** The answer sound (QC auto-scan, missing-field refusal): one high blip for OK, two low for a refusal. */
export function beep(ok: boolean) {
  try {
    const Ctx =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const tones = ok
      ? [[1320, 0]]
      : [
          [330, 0],
          [330, 0.18],
        ];
    for (const [hz, at] of tones) {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.frequency.value = hz!;
      g.gain.value = 0.08;
      o.connect(g).connect(ctx.destination);
      o.start(ctx.currentTime + at!);
      o.stop(ctx.currentTime + at! + 0.12);
    }
    window.setTimeout(() => void ctx.close(), 600);
  } catch {
    // No sound is fine; the toast still says it.
  }
}
